import Api from "./api";

class Moment {
	constructor(options) {
		this.options = Object.assign({},{
			value: Date.now(),
			pattern: 'dd.MMM.YYYY HH:mm:ss'
		}, options);

		this.dateRegExp = /(d+)|(E+)|(M+)|(Y+)|(H+)|(m+)|(s+)/g;

		this.E = null;
		this.d = null;
		this.M = null;
		this.Y = null;
		this.H = null;
		this.m = null;
		this.s = null;
		this.timestamp = null;

		this.initialDate = new Date(this.options.value);
		this.date = this.initialDate;
		this.dateString = null;

		this.generateDateString();
	}

	generateDateString() {
		this.dateString = this.format(this.options.pattern);
	}

	format(pattern) {
		let dateString = pattern;
		const matches = pattern.match(this.dateRegExp);

		const weekDay = this.date.getDay();
		const monthDay = this.date.getDate();
		const month = this.date.getMonth() + 1;
		const year = this.date.getFullYear();
		const hours = this.date.getHours();
		const minutes = this.date.getMinutes();
		const seconds = this.date.getSeconds();

		this.E = weekDay;
		this.d = monthDay;
		this.M = month;
		this.Y = year;
		this.H = hours;
		this.m = minutes;
		this.s = seconds;
		this.timestamp = this.date.getTime();

		matches.forEach((value, index) => {
			switch (value) {
				case 'dd': {
					const parsed = (monthDay < 10) ? `0${monthDay}` : monthDay;
					this.d = parsed;
					break;
				}
				case 'EE': {
					const weekDays = craft.localization.weekDays;
					const keys = Object.keys(weekDays);
					const weekDayKey = keys[weekDay];
					const parsed = weekDays[weekDayKey];
					this.E = parsed;
					break;
				}
				case 'MM': {
					const parsed = (month < 10) ? `0${month}` : month;
					this.M = parsed;
					break;
				}
				case 'MMM': {
					const monthNames = craft.localization.monthsWhen;
					const keys = Object.keys(monthNames);
					const monthKey = keys[month - 1];
					const parsed = monthNames[monthKey];
					this.M = parsed;
					break;
				}
				case 'YY': {
					const yearDigits = (year + '').split('');
					const parsed = `${yearDigits[2]}${yearDigits[3]}`
					this.Y = parsed;
					break;
				}
				case 'HH': {
					const parsed = (hours < 10) ? `0${hours}` : hours;
					this.H = parsed;
					break;
				}
				case 'mm': {
					const parsed = (minutes < 10) ? `0${minutes}` : minutes;
					this.m = parsed;
					break;
				}
				case 'ss': {
					const parsed = (seconds < 10) ? `0${seconds}` : seconds;
					this.s = parsed;
					break;
				}
			}

			dateString = dateString.replace(new RegExp(value, 'g'), this[value.charAt(0)]);
		});

		return dateString;
	}

	get weekDay() {
		return this.E;
	}

	get monthDay() {
		return this.d;
	}

	get month() {
		return this.M;
	}

	get year() {
		return this.Y;
	}

	get hours() {
		return this.H;
	}

	get minutes() {
		return this.m;
	}

	get seconds() {
		return this.s;
	}

	get() {
		return this.dateString;
	}

	getWeekDay() {
		return this.E;
	}

	getMonthDay() {
		return this.d;
	}

	getMonth() {
		return this.M;
	}

	getYear() {
		return this.Y;
	}

	getHours() {
		return this.H;
	}

	getMinutes() {
		return this.m;
	}

	getSeconds() {
		return this.s;
	}

	getTimestamp() {
		return this.timestamp;
	}

	getUnixTime() {
		return Math.floor(this.timestamp / 1000);
	}

	tomorrow(options = {}) {
		const config = Object.assign({}, this.options, options, {
			value: this.date.getTime() + DateHelper.getOneDayInMilliseconds()
		});
		return new Moment(config);
	}

	yesterday(options = {}) {
		const config = Object.assign({}, this.options, options, {
			value: this.date.getTime() - DateHelper.getOneDayInMilliseconds()
		});
		return new Moment(config);
	}
}

export default class DateHelper {
	static monthCountToTimestamp(qty) {
		if (typeof qty !== 'number') {
			throw new TypeError('DateHelper: Month quantity must be a number.');
		}

		return qty * 1000 * 60 * 60 * 24 * 30;
	}

	static getOneDayInMilliseconds() {
		return 86400000;
	}

	static getOneYearInSeconds() {
		return 31556926000;
	}

	static moment(options = {}) {
		return new Moment(options);
	}

	static fetchKyivCurrentUnixtime() {
		return Api.get(`${Api.restSiteUrl}/1.0/helper/unixtime`)
			.then((data) => {
				if (data.unixtime) {
					return data.unixtime;
				}

				return null;
			}).catch((err) => {
				console.error('Unixtime Fetch:', err);
			});
	}

	static areWorkingHours() {
		return DateHelper.fetchKyivCurrentUnixtime()
			.then((unixtime) => {
				if (unixtime) {
					const moment = DateHelper.moment({
						value: unixtime,
						pattern: 'dd.MM.YYYY'
					});

					let areWorkingHours = true;

					const weekDay = moment.getWeekDay();
					const hour = moment.getHours();

					const workingHoursBegin = 10;
					const workingHoursEnd = (weekDay === 6 || weekDay === 0) ? 19 : 21;

					if (hour >= workingHoursEnd && hour < 24) {
						areWorkingHours = false;
					} else if (hour >= 0 && hour < workingHoursBegin) {
						areWorkingHours = false;
					}

					return areWorkingHours;
				}

				return false;
			});
	}
}